import { c as _c } from "react/compiler-runtime";
import { cx } from "@/lib/tailwind-utils";
interface ServiceTitleProps {
  name: string;
  disabled?: boolean;
  className?: string;
}
export const ServiceTitle = t0 => {
  const $ = _c(6);
  const {
    name,
    disabled,
    className
  } = t0;
  const t1 = !disabled && "group-hover:text-foreground";
  let t2;
  if ($[0] !== className || $[1] !== t1) {
    t2 = cx("text-h4 font-medium tracking-tight text-foreground transition-colors duration-200", t1, className);
    $[0] = className;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== name || $[4] !== t2) {
    t3 = <h3 className={t2}>{name}</h3>;
    $[3] = name;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};